module.exports = __webpack_public_path__ + "img/time-example.22198b9d.png";